import { AIIcon } from '@cobliteam/ai';
import { useTranslation } from '@cobliteam/i18n';
import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import { cn } from '@cobliteam/ui/utils';
import { ShineTag } from '../ShineTag/ShineTag';

const ShineNew = (props: TagProps) => {
  return <ShineTag label={props.label || 'Novo'} {...props} />;
};

const New = (props: TagProps) => {
  return <Tag label={props.label || 'Novo'} {...props} color='success' />;
};

const AI = ({ className, style, animationActive = false, ...props }: TagProps & { animationActive?: boolean }) => {
  return (
    <Tag
      label={props.label || 'IA'}
      {...props}
      icon={<AIIcon size={22} animationActive={animationActive} sparklesPaint='brand-gradient' />}
      color='default'
      variant='default'
      style={style}
      className={cn(
        'border border-accessory-purple-6 bg-[linear-gradient(90deg,rgba(255,255,255,0.85)_0%,rgba(255,255,255,0.85)_100%),linear-gradient(90deg,#0745cf_0%,#9847ee_100%)] font-bold text-accessory-purple-11 shadow-none [&>div]:gap-0!',
        className
      )}
    />
  );
};

const Beta = (props: TagProps) => {
  const { t } = useTranslation('ui-business');
  return (
    <Tooltip content={t('release_phases.beta_public.description')} asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || t('release_phases.beta_public.label')} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const BetaPrivate = (props: TagProps) => {
  const { t } = useTranslation('ui-business');
  return (
    <Tooltip content={t('release_phases.beta_private.description')} asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || t('release_phases.beta_private.label')} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const BetaLimited = (props: TagProps) => {
  const { t } = useTranslation('ui-business');
  return (
    <Tooltip content={t('release_phases.beta_limited.description')} asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || t('release_phases.beta_limited.label')} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const Alpha = (props: TagProps) => {
  const { t } = useTranslation('ui-business');
  return (
    <Tooltip content={t('release_phases.alpha.description')} asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || t('release_phases.alpha.label')} {...props} color='purple' />
      </div>
    </Tooltip>
  );
};

export default {
  New,
  AI,
  Beta,
  BetaPrivate,
  BetaLimited,
  Alpha,
  ShineNew,
};
